import Typography from '@mui/material/Typography';

import { useBookingTypes } from 'reservations/form/hooks/useBookingTypes';

export const FormHeader = () => {
  const { isModify, isWaitlist } = useBookingTypes();

  let ctaText;
  switch (true) {
    case isModify:
      ctaText = 'Complete your updated reservation';
      break;
    case isWaitlist:
      ctaText = 'Join the waitlist';
      break;
    default:
      ctaText = 'Complete your reservation';
  }

  return (
    <>
      <Typography variant="h2">{ctaText}</Typography>
    </>
  );
};
